/*eslint-disable*/
import { FormControl, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { percentage } from "helpers/ValidationHelpers";
import React from "react";
import { Field } from "redux-form";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const GroupBenefits = (props) => (<Table>
  <TableHead>
    <TableRow>
      <TableCell
        className="cellPaddingSmall"
        style={colwidth("30em")}
      >
        {"Group / Employer Benefits"}
      </TableCell>
      <TableCell
        className="cellPaddingSmall"
        style={colwidth("15em")}
      >
        {"Multiple of Salary (As Capital)"}
      </TableCell>
      <TableCell
        className="cellPaddingSmall"
        style={colwidth("15em")}
      >
        {"% of Salary (As Income) "}
      </TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    <TableRow>
      <TableCell className="cellPaddingSmall">
        <Typography>Death</Typography>
      </TableCell>
      <TableCell className="cellPaddingSmall">
        <Typography>
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              checkValidation={props.checkValidation}
              onChange={() => props.forceUpdate()}
              name={`retirement_fund.group_benifits.death.multiple_of_salary`}
              label="Multiple of Salary"
            />
          </FormControl>
        </Typography>
      </TableCell>
      <TableCell className="cellPaddingSmall">
        <FormControl fullWidth>
          <Field
            component={NumberInput}
            suffix="%"
            validate={[percentage]}
            checkValidation={props.checkValidation}
            onChange={() => props.forceUpdate()}
            name={`retirement_fund.group_benifits.death.percent_of_salary`}
            label="% of Salary"
          />
        </FormControl>
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell padding="none" className="cellPaddingSmall">
        <Typography>Perm. Disability</Typography>
      </TableCell>
      <TableCell className="cellPaddingSmall">
        <Typography>
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              checkValidation={props.checkValidation}
              onChange={() => props.forceUpdate()}
              name={`retirement_fund.group_benifits.perm_disability.multiple_of_salary`}
              label="Multiple of Salary"
            />
          </FormControl>
        </Typography>
      </TableCell>
      <TableCell className="cellPaddingSmall">
        <FormControl fullWidth>
          <Field
            component={NumberInput}
            suffix="%"
            validate={[percentage]}
            checkValidation={props.checkValidation}
            onChange={() => props.forceUpdate()}
            name={`retirement_fund.group_benifits.perm_disability.percent_of_salary`}
            label="% of Salary"
          />
        </FormControl>
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell padding="none" className="cellPaddingSmall">
        <Typography>Severe Illness</Typography>
      </TableCell>
      <TableCell className="cellPaddingSmall">
        <Typography>
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              checkValidation={props.checkValidation}
              onChange={() => props.forceUpdate()}
              name={`retirement_fund.group_benifits.severe_illness.multiple_of_salary`}
              label="Multiple of Salary"
            />
          </FormControl>
        </Typography>
      </TableCell>
      <TableCell className="cellPaddingSmall" />
    </TableRow>
  </TableBody>
</Table>)

export default GroupBenefits;


// WEBPACK FOOTER //
// ./src/views/Fna/steps/RetirementFund/components/GroupBenifits.jsx